import { render, staticRenderFns } from "./CorporateMember.vue?vue&type=template&id=4e2165cb&scoped=true"
import script from "./CorporateMember.vue?vue&type=script&lang=js"
export * from "./CorporateMember.vue?vue&type=script&lang=js"
import style0 from "./CorporateMember.vue?vue&type=style&index=0&id=4e2165cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2165cb",
  null
  
)

export default component.exports